import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Video, Calendar, Users, DollarSign } from "lucide-react";

export default function Webinars() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/webinars").then(r => setRows(r.data)); }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA] p-6 lg:p-10" data-testid="webinars-page">
      <div className="flex items-center gap-3 mb-6">
        <Video className="h-6 w-6 text-violet-600" />
        <div>
          <h1 className="font-display text-3xl font-bold">Webinar & Event System</h1>
          <p className="text-sm text-zinc-500 mt-1">Turn audiences into high-paying clients</p>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-5">
        {rows.map((w) => (
          <div key={w.id} className="rounded-3xl bg-white border border-black/5 overflow-hidden" data-testid={`webinar-${w.id}`}>
            <div className="ashra-gradient-bg p-5 text-white">
              <p className="text-[11px] uppercase tracking-wider opacity-80">{w.status === "upcoming" ? "Upcoming Webinar" : "Past Webinar"}</p>
              <h3 className="mt-1 font-display text-xl font-bold">{w.title}</h3>
              <p className="mt-2 text-xs inline-flex items-center gap-1"><Calendar className="h-3 w-3" /> {new Date(w.starts_at).toLocaleString()}</p>
            </div>
            <div className="p-5 grid grid-cols-4 gap-3 text-center text-sm">
              <div><p className="text-[10px] text-zinc-500 uppercase">Registrations</p><p className="font-display text-xl font-bold">{w.registrations.toLocaleString()}</p></div>
              <div><p className="text-[10px] text-zinc-500 uppercase">Attendees</p><p className="font-display text-xl font-bold">{w.attendees.toLocaleString()}</p></div>
              <div><p className="text-[10px] text-zinc-500 uppercase">Conversions</p><p className="font-display text-xl font-bold text-violet-600">{w.conversions}</p></div>
              <div><p className="text-[10px] text-zinc-500 uppercase">Revenue</p><p className="font-display text-xl font-bold text-emerald-600">${(w.revenue/1000).toFixed(0)}K</p></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
